
<div ui-card [type]="alertType">
  <div class="ui-alert-layout">
    <mat-icon *ngIf="alertIcon" class="ui-alert-icon">{{ alertIcon }}</mat-icon>
    <div class="ui-alert-content">
      <ng-content select="[ui-header]" ngProjectAs="[ui-header]"></ng-content>
      <ng-content select="[ui-body]" ngProjectAs="[ui-body]"></ng-content>
      <ng-content select="[ui-footer]" ngProjectAs="[ui-footer]"></ng-content>
      <ng-content></ng-content>
    </div>
  </div>
</div>
